export default {"src":"/_next/static/image/public/images/order_payment_fail_img.0c01b18560d6564816ac4918448a1eaa.svg","height":153,"width":189};